export const tdkConfig: Record<
  string,
  { title: string; description: string; keywords: string }
> = {
  "/": {
    title: process.env.REACT_APP_META_TITLE || "",
    description: process.env.REACT_APP_META_DESCRIPTION || "",
    keywords: process.env.REACT_APP_META_KEYWORDS || "",
  },
  "/news": {
    title: "最新消息與滑雪資訊｜Jstyle Ski 官方資訊",
    description:
      "彙整 Jstyle Ski 最新消息與滑雪專欄內容，提供日本各大雪場的官方公告、季節動態與滑雪知識分享，涵蓋北海道札幌手稻、星野渡假村、札幌國際、富良野、ONZE、藏王溫泉，以及比羅夫、安努普利、留壽都渡假村、喜樂樂渡假村等雪場資訊，供滑雪愛好者即時參考。",
    keywords:
      "滑雪資訊專欄,日本滑雪動態,北海道滑雪資訊,星野滑雪資訊,星野滑雪動態,藏王滑雪資訊,札幌滑雪近況,雪場公告,滑雪教學文章,Jstyle Ski 最新消息",
  },
  "/trainers": {
    title: "教練介紹｜Jstyle Ski 專業教學團隊",
    description:
      "尋找專業中文滑雪教練？Jstyle Ski 提供星野與北海道等雪場的單板、雙板教學特色介紹。選好心儀教練後，請回 Jstyleski 官網首頁預約課程，開啟你的日本滑雪冒險！",
    keywords:
      "滑雪教練介紹,Jstyle Ski 教練,單板滑雪教練,雙板滑雪教練,滑雪教學經驗",
  },
  "/trainers/info": {
    title: "教練介紹｜Jstyle Ski 專業教學團隊",
    description:
      "尋找專業中文滑雪教練？Jstyle Ski 提供星野與北海道等雪場的單板、雙板教學特色介紹。選好心儀教練後，請回 Jstyleski 官網首頁預約課程，開啟你的日本滑雪冒險！",
    keywords:
      "滑雪教練介紹,Jstyle Ski 教練,單板滑雪教練,雙板滑雪教練,滑雪教學經驗",
  },
  "/yuzawa-ski": {
    title:
      "湯澤滑雪教練｜神樂・苗場・舞子・岩原・神立・石打丸山・中里｜Jstyle Ski",
    description:
      "Jstyle Ski 提供湯澤地區中文滑雪教練與單板、雙板滑雪課程，涵蓋神樂、苗場、舞子、岩原、神立、石打丸山與中里等人氣滑雪場，適合初學者、親子及東京出發的日本滑雪行程。",
    keywords:
      "湯澤滑雪教練, 越後湯澤滑雪教練, 苗場滑雪教練, 舞子滑雪教練, 神樂滑雪教練, 岩原滑雪教練, 神立滑雪教練, 石打丸山滑雪教練, 中里滑雪教練, 湯澤中文滑雪教練, 中文滑雪教練, 單板滑雪教練, 雙板滑雪教練",
  },
  "/hoshino-ski": {
    title: "星野滑雪教練｜Tomamu 中文滑雪課程與雪場介紹｜Jstyle Ski",
    description:
      "Jstyle Ski 提供星野 Tomamu 中文滑雪教練與滑雪課程介紹，適合初學者與家庭滑雪行程，提供單板與雙板滑雪教學，輕鬆安排北海道滑雪體驗。",
    keywords:
      "星野滑雪教練, Tomamu滑雪, 星野中文滑雪教練, 北海道滑雪課程, 單板滑雪教學, 雙板滑雪教學",
  },
  "/rusutsu-ski": {
    title: "留壽都滑雪教練｜北海道粉雪滑雪課程與雪場介紹｜Jstyle Ski",
    description:
      "留壽都滑雪場以豐富粉雪與多樣滑行路線聞名。Jstyle Ski 提供中文滑雪教練與單板、雙板滑雪課程，適合進階與深度滑雪行程安排。",
    keywords:
      "留壽都滑雪教練, 留壽都滑雪場, Rusutsu滑雪, 北海道粉雪, 中文滑雪教練, 單板滑雪課程",
  },
  "/teine-ski": {
    title: "札幌手稻滑雪教練｜札幌近郊滑雪場與課程介紹｜Jstyle Ski",
    description:
      "札幌手稻滑雪場交通便利，是札幌近郊熱門滑雪選擇。Jstyle Ski 提供中文滑雪教練與滑雪課程，適合短天數與初學者滑雪體驗。",
    keywords:
      "手稻滑雪教練, 札幌手稻滑雪場, Teine滑雪, 札幌滑雪推薦, 中文滑雪教練",
  },
  "/onze-ski": {
    title: "ONZE滑雪場教練｜札幌近郊滑雪課程與雪場介紹｜Jstyle Ski",
    description:
      "ONZE滑雪場鄰近札幌與小樽，適合初學者與輕鬆滑雪行程。Jstyle Ski 提供中文滑雪教練與滑雪課程介紹，輕鬆安排北海道滑雪體驗。",
    keywords: "ONZE滑雪場, ONZE滑雪教練, 小樽ONZE, 札幌滑雪課程, 中文滑雪教練",
  },
};
